"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

export const softAgeVerificationButtonsComponentName =
  "Soft Age Verification Buttons";

export const birthDateFormCtasInputs = [
  {
    name: "confirmLabel",
    type: "string",
    defaultValue: "Confirm",
    required: true,
  },
  {
    name: "leaveLabel",
    type: "string",
    defaultValue: "Leave",
    required: true,
  },
  {
    name: "leaveUrl",
    type: "string",
    defaultValue: "https://www.google.com",
    required: true,
  },
] as const satisfies Inputs;

export const BirthDateFormCtasComponent: RegisteredComponent = {
  name: softAgeVerificationButtonsComponentName,
  inputs: birthDateFormCtasInputs,
  models: [getBuilderModelName("soft-age-verification")],
  noWrap: true,
  component: dynamic(
    async () => (await import("./BirthDateFormCtas")).BirthDateFormCtas
  ),
};
